import {localize} from "@agenta/i18n"

import type {SidebarEntitySource} from "./types"

/**
 * The placeholder row's text. `emptyLabel` is a catalog key (an entity's static config cannot
 * hold translated text), resolved here at render; plain text passes through unchanged.
 */
export const getSidebarSourceStatusLabel = (
    status: SidebarEntitySource["status"],
    emptyLabel = "com_nav_no_items",
) => {
    switch (status) {
        case "idle":
            return localize("com_nav_open_to_load")
        case "loading":
            return localize("com_nav_loading")
        case "error":
            return localize("com_nav_failed_to_load")
        case "ready":
            return localize(emptyLabel)
    }
}
